import { GraphQLQueryClass } from "@bsm/component";
import { TUserStudentScholarity } from "@bsm/graphql";

export class ScholarityQuery implements GraphQLQueryClass<TUserStudentScholarity, TResponse>
{
    public queryKey: string = "App.Bsm.Students.ScholarityQuery";

    public gql: string = `
    query($id:Float!){
        userStudentScholarity(filter:{id:$id}){
            id
            schoolFeeAmount
            registrationFeeAmount
            scholarityClass {
                id
                level {
                    id
                    value
                }
                class {
                    id
                    value
                }
            }
            students {
                id
                isEnrolled
                user {
                    id
                    fullName
                }
                scholarities {
                    id
                    state
                    scholarityClass {
                        id
                    }
                }
            }
            state
            designation
            schoolYear
            monthBegin
            monthEnd
            isDeletable
            isEditable
        }
    }
   `;
    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TUserStudentScholarity {
        return data.userStudentScholarity;
    }
}

export type TResponse = {
    userStudentScholarity: TUserStudentScholarity;
};
